var exports = {
  "kL": "xf0b3b88a--638dfe--container",
  "Qs": "xf0b3b88a--638dfe--content",
  "iW": "xf0b3b88a--638dfe--main",
  "Yq": "xf0b3b88a--638dfe--reviews",
  "HU": "xf0b3b88a--638dfe--aside",
  "l3": "xf0b3b88a--638dfe--back_button",
};

module.exports = exports;
